import React, { useState } from 'react'
import {
  Container,
  Icon,
  Link,
  ListContainer,
  TextBody,
  TextTitle,
  Tools
} from '@pdrj/pmi-iqos-ds-react'
import { Assets, LazyImage } from '@pdrj/pmi-iqos-shared-react'
import SpotsUsageBadge from './spots-usage-badge'
import SpotsMapsButton from './spots-maps-button'
import SpotsStoreLink from './spots-store-link'

const SpotsMapDetailPopup = ({
  spot,
  usageTypes,
  onCloseHandler,
  fullDetail,
  setFullDetail,
  translations
}) => {
  const [viewMore, setViewMore] = useState(false)

  const handleViewMoreDetails = () => {
    !Tools.isDesktop() && setFullDetail(true)
    setViewMore(true)
  }

  const renderViewMore = () => {
    return (
      <TextBody>
        <Link
          onClickHandler={handleViewMoreDetails}
          data-testing="SpotsMapDetailPopup_Link_ViewMore">
          {translations.tk_viewMore}
        </Link>
      </TextBody>
    )
  }

  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.column}
      fullWidth
      fullHeight
      bg={Container.backgrounds.white}>
      <Container pt="6" pb="8" px="8">
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.row}
          justifyContent={Container.justifyContentValues.end}>
          <Container
            onClickHandler={onCloseHandler}
            data-testing="SpotsMapDetailPopup_Container_Close">
            <Icon image={Icon.images.cancel} />
          </Container>
        </Container>
        <Container
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}>
          <Container
            pt="6"
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}>
            <Container
              position={Container.positions.relative}
              display={Container.displays.flex}
              flexDirection={Container.flexDirections.row}
              justifyContent={Container.justifyContentValues.center}
              fullWidth>
              <LazyImage
                height="36"
                src={spot.spotImage || Assets.urls.imageSpotDefault}
                cover
              />
            </Container>
          </Container>
          <Container pt="4">
            <TextTitle
              ellipsis={!fullDetail}
              heading={TextTitle.headings.h6}
              data-testing="SpotsMapDetailPopup_TextTitle_SpotName">
              {spot.spotName}
            </TextTitle>
          </Container>
          <Container pt="2">
            <TextBody size={TextBody.sizes.s}>
              {spot.prefecture} {spot.address}
            </TextBody>
          </Container>
          <Container>
            <TextBody size={TextBody.sizes.s}>
              {translations.tk_telephone} {spot.telephone}
            </TextBody>
          </Container>
          <Container
            pt="4"
            display={Container.displays.flex}
            flexDirection={Container.flexDirections.row}
            justifyContent={Container.justifyContentValues.between}>
            <SpotsMapsButton spot={spot} translations={translations} />
            {!viewMore && !Tools.isDesktop() ? renderViewMore() : null}
          </Container>
          {!viewMore && Tools.isDesktop() ? (
            <Container
              pt="8"
              fullWidth
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}>
              {renderViewMore()}
            </Container>
          ) : null}
          {viewMore && (
            <Container pt="4">
              <ListContainer xBetween="8" yBetween="8" columns={1}>
                <SpotsStoreLink
                  spot={spot}
                  translations={translations}
                  data-testing-prefix="SpotsMapDetailPopup"
                />
                <TextBody size={TextBody.sizes.s}>{spot.description}</TextBody>
                <SpotsUsageBadge noBg spot={spot} usageTypes={usageTypes} />
              </ListContainer>
            </Container>
          )}
        </Container>
      </Container>
    </Container>
  )
}

export default SpotsMapDetailPopup
